import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  mutation UpdateThreadAnswer(
    $courseId: String!
    $threadId: String!
    $answerId: String!
    $input: CreateThreadAnswerInput!
  ) {
    updateThreadAnswer(
      courseId: $courseId
      threadId: $threadId
      answerId: $answerId
      input: $input
    )
      @rest(
        type: "ThreadAnswer"
        path: "courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}"
        method: "PUT"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
